import React from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { toKebabCase } from '@uplift/utils';

import { Loader } from '../../Loader';
import { ScrollableView } from '../components';
import { ReviewLayoutContentControls } from './ReviewLayout.component';

const useStyles = makeStyles({ name: 'ReviewLayoutContent' })(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    maxWidth: '730px',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 500,
  },
  reviewSection: {
    maxWidth: 'min(calc(100% - 44px), 570px)',
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(2, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(5, 0),
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
}));


export type ReviewLayoutContentProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  contentSpacing?: boolean;
  showControls?: boolean;
};


export const ReviewLayoutContent: React.FC<ReviewLayoutContentProps> = ({ contentSpacing = true, showControls = true, ...props }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <React.Suspense fallback={<Loader color="secondary" />}>
        <ScrollableView height="100%">
          <Box className={classes.reviewSection}>
            <React.Suspense fallback={<Loader color="secondary" />}>
              <Box className={classes.content}>
                <Box className={classes.title}>
                  <Typography data-testid={toKebabCase(props.title?.toString() || 'client-activity-title')}>{props.title}</Typography>
                  {props.subtitle && <Typography>{props.subtitle}</Typography>}
                </Box>
                <Box pt={2}>
                  <Divider />
                </Box>
                <Box pt={contentSpacing ? 2 : 0}>
                  {props.children}
                </Box>
              </Box>
            </React.Suspense>
          </Box>
        </ScrollableView>
        {showControls && <ReviewLayoutContentControls />}
      </React.Suspense>
    </Box>
  );
};
